import PropTypes from 'prop-types';

/** Surface card. `featured` renders the dark pricing style (is_featured_dark). */
export function Card({ featured = false, className = '', children, ...rest }) {
  const base = featured
    ? 'bg-featured text-featured-text'
    : 'bg-white text-slate-900 border border-slate-200';
  return (
    <div className={`rounded-dc p-6 shadow-dc ${base} ${className}`} {...rest}>
      {children}
    </div>
  );
}

Card.propTypes = {
  featured: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};
